import { render, staticRenderFns } from "./ListKirimBalik.vue?vue&type=template&id=238dc5f0&"
import script from "./ListKirimBalik.vue?vue&type=script&lang=js&"
export * from "./ListKirimBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports